import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-widget-principal-data',
  templateUrl: './widget-principal-data.component.html',
  styleUrls: ['./widget-principal-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class WidgetPrincipalDataComponent {
  @Input() data: any;

  @Input() label?: string;

  @Input() progress?: number;
  @Input() progressColor?: string = '#10B981';

  @Input() isDataGrid: boolean = false;
  @Input() showData: boolean = false;
}
